/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateComponentMutationVariables = Types.Exact<{
  name: Types.Scalars["String"]["input"];
  projectLanguage: Types.InputMaybe<Types.ProjectLanguage>;
  description: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  kernelSize: Types.InputMaybe<Types.Scalars["KernelSize"]["input"]>;
  kernelImage: Types.InputMaybe<Types.Scalars["KernelImage"]["input"]>;
  cellIdsToCopy: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["CellId"]["input"]>
    | Types.Scalars["CellId"]["input"]
  >;
  autoPublish: Types.Scalars["Boolean"]["input"];
}>;

export type CreateComponentMutation = {
  readonly __typename: "Mutation";
  readonly createHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly title: string;
    readonly lastPublishedVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
    } | null;
  };
};

export const CreateComponentDocument = /*#__PURE__*/ gql`
  mutation CreateComponent(
    $name: String!
    $projectLanguage: ProjectLanguage
    $description: String
    $kernelSize: KernelSize
    $kernelImage: KernelImage
    $cellIdsToCopy: [CellId!]
    $autoPublish: Boolean!
  ) {
    createHex(
      name: $name
      projectLanguage: $projectLanguage
      description: $description
      kernelSize: $kernelSize
      kernelImage: $kernelImage
      cellIdsToCopy: $cellIdsToCopy
      autoPublish: $autoPublish
      hexType: COMPONENT
    ) {
      id
      title
      lastPublishedVersion {
        id
      }
    }
  }
`;
export type CreateComponentMutationFn = Apollo.MutationFunction<
  CreateComponentMutation,
  CreateComponentMutationVariables
>;

/**
 * __useCreateComponentMutation__
 *
 * To run a mutation, you first call `useCreateComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComponentMutation, { data, loading, error }] = useCreateComponentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      projectLanguage: // value for 'projectLanguage'
 *      description: // value for 'description'
 *      kernelSize: // value for 'kernelSize'
 *      kernelImage: // value for 'kernelImage'
 *      cellIdsToCopy: // value for 'cellIdsToCopy'
 *      autoPublish: // value for 'autoPublish'
 *   },
 * });
 */
export function useCreateComponentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateComponentMutation,
    CreateComponentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateComponentMutation,
    CreateComponentMutationVariables
  >(CreateComponentDocument, options);
}
export type CreateComponentMutationHookResult = ReturnType<
  typeof useCreateComponentMutation
>;
export type CreateComponentMutationResult =
  Apollo.MutationResult<CreateComponentMutation>;
export type CreateComponentMutationOptions = Apollo.BaseMutationOptions<
  CreateComponentMutation,
  CreateComponentMutationVariables
>;
